export const SEARCH_PAGE = 'search-page';
